import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-combustiveis',
  template: `
    <div class="row">
      <div class="col">
        <p>COMBUSTÍVEL</p>
      </div>
      <div class="col">
        <p>PREÇO DE BOMBA</p>
      </div>
      <div class="col">
        <p>DESCONTO SPS</p>
      </div>
      <div class="col" *ngIf="comRedeEspecial">
        <p>DESCONTO REDE ESPECIAL</p>
      </div>
      <div class="col" *ngIf="precosComValores">
        <p>ÚLTIMA ATUALIZAÇÃO</p>
      </div>
   
    </div>
  `,
  styles: [
    `
      p {
        font-weight: 700;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: -0.4px;
      }
    `,
  ],
})
export class MenuCombustiveisComponent implements OnInit {
  @Input() comRedeEspecial: boolean = false;
  @Input() precosComValores: boolean = true;
  
  constructor() {}

  ngOnInit(): void {}
}
